import { CONFIG } from '@/app.config';

const Time = {
  data() {
    return {
      timeData: {
        hour: [
          { description: '01' },
          { description: '02' },
          { description: '03' },
          { description: '04' },
          { description: '05' },
          { description: '06' },
          { description: '07' },
          { description: '08' },
          { description: '09' },
          { description: '10' },
          { description: '11' },
          { description: '12' },
        ],
        hour24: [
          { description: '00' },
          { description: '01' },
          { description: '02' },
          { description: '03' },
          { description: '04' },
          { description: '05' },
          { description: '06' },
          { description: '07' },
          { description: '08' },
          { description: '09' },
          { description: '10' },
          { description: '11' },
          { description: '12' },
          { description: '13' },
          { description: '14' },
          { description: '15' },
          { description: '16' },
          { description: '17' },
          { description: '18' },
          { description: '19' },
          { description: '20' },
          { description: '21' },
          { description: '22' },
          { description: '23' },
        ],
        minutes: [
          { description: '00' },
          { description: '01' },
          { description: '02' },
          { description: '03' },
          { description: '04' },
          { description: '05' },
          { description: '06' },
          { description: '07' },
          { description: '08' },
          { description: '09' },
          { description: '10' },
          { description: '11' },
          { description: '12' },
          { description: '13' },
          { description: '14' },
          { description: '15' },
          { description: '16' },
          { description: '17' },
          { description: '18' },
          { description: '19' },
          { description: '20' },
          { description: '21' },
          { description: '22' },
          { description: '23' },
          { description: '24' },
          { description: '25' },
          { description: '26' },
          { description: '27' },
          { description: '28' },
          { description: '29' },
          { description: '30' },
          { description: '31' },
          { description: '32' },
          { description: '33' },
          { description: '34' },
          { description: '35' },
          { description: '36' },
          { description: '37' },
          { description: '38' },
          { description: '39' },
          { description: '40' },
          { description: '41' },
          { description: '42' },
          { description: '43' },
          { description: '44' },
          { description: '45' },
          { description: '46' },
          { description: '47' },
          { description: '48' },
          { description: '49' },
          { description: '50' },
          { description: '51' },
          { description: '52' },
          { description: '53' },
          { description: '54' },
          { description: '55' },
          { description: '56' },
          { description: '57' },
          { description: '58' },
          { description: '59' },
        ],
        state: [{ description: 'AM' }, { description: 'PM' }],
        state24: [{ description: 'H' }],
      },
    };
  },
  methods: {
    getTime(hour, minutes) {
      if (CONFIG.HOUR24) {
        const h = hour < 10 ? `0${hour}` : hour;
        const m = minutes < 10 ? `0${minutes}` : minutes;
        return `${h}:${m}`;
      }

      const h = hour % 12 || 12;
      const m = minutes < 10 ? `0${minutes}` : minutes;
      const ampm = hour < 12 ? 'AM' : 'PM';
      return `${h}:${m} <span>${ampm}</span>`;
    },

    getTimeObject(hour, minutes) {
      if (CONFIG.HOUR24) {
        const h = hour < 10 ? `0${hour}` : String(hour);
        const m = minutes < 10 ? `0${minutes}` : String(minutes);
        return { hour: h, minutes: m, ampm: '' };
      }

      let h = hour % 12 || 12;
      h = h < 10 ? `0${h}` : String(h);
      const m = minutes < 10 ? `0${minutes}` : String(minutes);
      const ampm = hour < 12 ? 'AM' : 'PM';
      return { hour: h, minutes: m, ampm };
    },
  },
};

export default Time;
